import { Injectable } from '@angular/core';
import {
	FilterParams,
	RepositoryService,
} from '../../../helpers/crud/repository.service';
import { Spot } from '../model/spot.model';
import { WancomHttpService } from '../../../services/wancom-http/wancom-http.service';
import { WaitingService } from '../../layout/waiting/waiting.service';
import { TypeModeration } from '../model/moderation-media.model';

@Injectable({
	providedIn: 'root',
})
export class SpotService extends RepositoryService<Spot> {
	constructor(http: WancomHttpService, waiting$: WaitingService) {
		super(http, waiting$, 'spots');
	}

	isStaticSpot(id: number) {
		if (id) return this.http.get<Spot>(`${this.url}/isStaticSpot/${id}`);
	}

	getSpotName(id: number) {
		if (id) return this.http.get<{name: string}>(`${this.url}/getSpotName/${id}`);
	}
}

@Injectable()
export class SpotFilterParams extends FilterParams {
	name: string;
	organizationId: any;
	spotDuration: any;
	spotType: any;
	formatTypes: any;
	Activities: any;
	isTemplate: boolean;
	mediaLibraryId: number;
	forFaceId?: number;
	shelfId: number;
	typeModerations?: TypeModeration[];
	diffusionId?: number;
}
